(function($) {
    class StickyHeader {
        constructor() {
            this.init();
        }

        init() {
            this.$header = $('.w4d-header');
            this.headerHeight = this.$header.outerHeight();
            this.lastScrollTop = 0;
            this.delta = 5; // Minimum amount to consider a scroll
            this.scrollTimeout = null;

            document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);

            this.bindEvents();
        }

        bindEvents() {
            $(window).on('scroll', () => {
                if (!this.scrollTimeout) {
                    this.scrollTimeout = window.requestAnimationFrame(() => {
                        this.handleScroll();
                        this.scrollTimeout = null;
                    });
                }
            });

            $(window).on('resize', () => {
                this.headerHeight = this.$header.outerHeight();
                document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
            });
        }

        handleScroll() {
            const scrollTop = $(window).scrollTop();

            if (scrollTop > this.headerHeight && scrollTop > this.lastScrollTop && Math.abs(this.lastScrollTop - scrollTop) > this.delta) {
                this.$header.addClass('w4d-header--hidden');
            } else if (scrollTop < this.lastScrollTop && Math.abs(this.lastScrollTop - scrollTop) > this.delta) {
                this.$header.removeClass('w4d-header--hidden');
            }

            this.lastScrollTop = scrollTop;
        }
    }

    $(document).ready(() => new StickyHeader());
})(jQuery);